import { Button, Flex } from '@iheartjane/reefer';

import { useModalActionsWithTracking } from '@jane/business-admin/hooks';
import { ModalNames } from '@jane/business-admin/util';

import { AppearanceModal } from './AppearanceModal';
import { CarouselModal } from './carouselModal/CarouselModal';
import { CommsBannerModal } from './commsBannerModal/CommsBannerModal';
import { FiltersAndLabelsModal } from './filtersAndLabelsModal/FiltersAndLabelsModal';

export const StoreMenuHeader = () => {
  const {
    modalOpen: commsBannerModalOpen,
    openModal: setCommsBannerModalOpen,
    closeModal: setCommsBannerModalClose,
  } = useModalActionsWithTracking(ModalNames.CommsBanner);
  const {
    modalOpen: appearanceModalOpen,
    openModal: setAppearanceModalOpen,
    closeModal: setAppearanceModalClose,
  } = useModalActionsWithTracking(ModalNames.Appearance);
  const {
    modalOpen: filtersAndLabelsModalOpen,
    openModal: setFiltersAndLabelsModalOpen,
    closeModal: setFiltersAndLabelsModalClose,
  } = useModalActionsWithTracking(ModalNames.FiltersAndLabels);
  const {
    modalOpen: carouselModalOpen,
    openModal: setCarouselModalOpen,
    closeModal: setCarouselModalClose,
  } = useModalActionsWithTracking(ModalNames.Carousel);

  return (
    <>
      <Flex width="100%" justifyContent="space-between">
        <Flex gap={16}>
          <Button
            label="Customize appearance"
            variant="secondary"
            onClick={() => setAppearanceModalOpen()}
          />
          <Button
            label="Edit banner"
            variant="secondary"
            onClick={() => setCommsBannerModalOpen()}
          />
          <Button
            label="Edit filters and labels"
            onClick={() => setFiltersAndLabelsModalOpen()}
            variant="secondary"
          />
          <Button
            label="Edit carousel"
            variant="secondary"
            onClick={() => setCarouselModalOpen()}
          />
        </Flex>
      </Flex>

      {filtersAndLabelsModalOpen && (
        <FiltersAndLabelsModal
          closeModal={() => setFiltersAndLabelsModalClose()}
        />
      )}

      {commsBannerModalOpen && (
        <CommsBannerModal closeModal={() => setCommsBannerModalClose()} />
      )}

      {appearanceModalOpen && (
        <AppearanceModal closeModal={() => setAppearanceModalClose()} />
      )}

      {carouselModalOpen && (
        <CarouselModal closeModal={() => setCarouselModalClose()} />
      )}
    </>
  );
};
